import { render, staticRenderFns } from "./histogram.vue?vue&type=template&id=6664275a&"
import script from "./histogram.vue?vue&type=script&lang=ts&"
export * from "./histogram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6664275a')) {
      api.createRecord('6664275a', component.options)
    } else {
      api.reload('6664275a', component.options)
    }
    module.hot.accept("./histogram.vue?vue&type=template&id=6664275a&", function () {
      api.rerender('6664275a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/histogram.vue"
export default component.exports